import { Component, Prop, h, Host, Element, Watch } from '@stencil/core';

@Component({
  tag: 'dda-home-carousel',
  styleUrls: ['dda-home-carousel.css'],
  shadow: false,
})
export class DdaHomeCarousel {
  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;
  @Prop() items_in_view: number = 5;
  @Prop() bannercardlist: string | any[] = [];

  @Element() el: HTMLElement;

  private containerRef: HTMLElement;
  private parsedCardList: any[] = [];

  @Watch('bannercardlist')
  parseBannerCardList(newValue: string | any[]) {
    if (typeof newValue === 'string') {
      try {
        this.parsedCardList = JSON.parse(newValue);
      } catch (e) {
        console.error('Invalid JSON for bannercardlist:', e);
        this.parsedCardList = [];
      }
    } else if (Array.isArray(newValue)) {
      this.parsedCardList = newValue;
    } else {
      this.parsedCardList = [];
    }
  }

  componentWillLoad() {
    this.parseBannerCardList(this.bannercardlist);
  }

  componentDidLoad() {
    this.containerRef = this.el.querySelector('.dda-home-carousel-track');
    this.containerRef.addEventListener('mousemove', this.handleMouseMove);
    this.containerRef.addEventListener('mouseleave', this.handleMouseLeave);
    this.containerRef.querySelectorAll('img').forEach((img) => {
      img.addEventListener('dragstart', (e) => e.preventDefault());
    });

    // ===== Add single-active click behavior =====
    // this.containerRef.querySelectorAll('button.dda-banner-card').forEach((btn) => {
    //   btn.addEventListener('click', (e) => {
    //     // Remove .active from all buttons
    //     this.containerRef.querySelectorAll('button.dda-banner-card.active').forEach((activeBtn) => {
    //       activeBtn.classList.remove('active');
    //     });
    //     // Add .active to clicked button
    //     (e.currentTarget as HTMLElement).classList.add('active');
    //   });
    // });
  }

  disconnectedCallback() {
    this.containerRef?.removeEventListener('mousemove', this.handleMouseMove);
    this.containerRef?.removeEventListener('mouseleave', this.handleMouseLeave);
  }

  handleMouseMove = (e: MouseEvent) => {
    if (!this.containerRef) return;

    const rect = this.containerRef.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const percentage = mouseX / rect.width;
    const maxScroll = this.containerRef.scrollWidth - this.containerRef.clientWidth;
    const isRTL = getComputedStyle(this.containerRef).direction === 'rtl';

    const targetScroll = isRTL
      ? maxScroll - percentage * maxScroll
      : percentage * maxScroll;

    this.containerRef.scrollLeft = isRTL ? -targetScroll : targetScroll;
  };

  handleMouseLeave = () => {
    const itemWidth = this.containerRef.scrollWidth / this.parsedCardList.length;
    const index = Math.round(this.containerRef.scrollLeft / itemWidth);
    this.containerRef.scrollTo({ left: index * itemWidth, behavior: 'smooth' });
  };

  handleCardClick(item: any) {
    console.log('Card clicked from carousel:', item);


    
    // Remove .active from all banner cards
    this.containerRef
      ?.querySelectorAll('button.dda-banner-card.active')
      .forEach((btn) => btn.classList.remove('active'));

    // Add .active to the clicked banner card
    const clickedBtn = this.containerRef?.querySelector(
      `button#${item.banner_card_id}`
    );
    clickedBtn?.classList.add('active');



    this.el.dispatchEvent(
      new CustomEvent('cardClick', {
        detail: item,
        bubbles: true,
        composed: true,
      })
    );
  }

  render() {
    const cardClass = ['dda-home-carousel', this.custom_class, this.component_mode]
      .filter(Boolean)
      .join(' ');
    const itemWidth = 100 / this.items_in_view;

    return (
      <Host>
        <div
          class={cardClass}
          role="region"
          aria-roledescription="carousel"
          aria-label="Banner cards carousel"
        >
          <div
            class="dda-home-carousel-track"
            ref={(el) => (this.containerRef = el)}
            role="list"
            tabIndex={0}
            aria-live="polite"
          >
            {this.parsedCardList.map((item, index) => (
              <div
                class="dda-home-carousel-item"
                key={item.banner_card_id || index}
                style={{ flex: `0 0 ${itemWidth}%` }}
                role="listitem"
                tabIndex={-1}
                aria-label={`${item.banner_card_title || 'Carousel item'} ${index + 1} of ${this.parsedCardList.length}`}
              >
                <dda-banner-card
                  image_src={item.image_src}
                  image_alt={item.image_alt}
                  banner_card_title={item.banner_card_title}
                  banner_card_description={item.banner_card_description}
                  banner_card_id={item.banner_card_id || `card-${index}`}
                  banner_card_value={item.banner_card_value}
                  banner_card_name={item.banner_card_name}
                  custom_class={item.custom_class || ''}
                  component_mode={item.component_mode || ''}
                  onClick={() => this.handleCardClick(item)}
                ></dda-banner-card>
              </div>
            ))}
          </div>
        </div>
      </Host>
    );
  }
}
